import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../../../core';
import { Observable, of } from 'rxjs';
import { dataMember, deserialize, required, typedArray } from 'santee-dcts';
import { map } from 'rxjs/operators';

@Injectable()
export class UserEmailsStorage {
    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings,
    ) {
    }

    public search(searchTerm: string, accessionNumber: string): Observable<string[]> {
        return searchTerm ? this.http.get(`${this.settings.apiUrl}/admin/e-query-user-emails`, {params: {searchTerm: searchTerm, accessionNumber: accessionNumber}})
                .pipe(map(mails => deserialize(mails, AdminEQueryUserEmailsReadModel).mails))
            : of([]);
    }
}

export class AdminEQueryUserEmailsReadModel {
    @dataMember()
    @required()
    @typedArray(String)
    public mails: string[];
}
